import { Box, FormControl, Grid, IconButton, MenuItem, Radio, Select, Typography } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../../assets/jss/Dialog";
import { TripSubTypeEnum, TripTypeEnum } from "../../../config/app-globals.enum";
import { switchTrip } from "../../../services/SwitchTripService";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogAction from "../../CustomComponents/CustomDialogAction/CustomDialogAction";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import ErrorAlert from '../../ErrorAlert/ErrorAlert';


const styles = (theme) => ({});

const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);

export default function SwitchTripDialog(props) {
	const { t } = useTranslation();
	const classes = useStyles();
	const [open, setOpen] = React.useState(props.dialogOpen);

	const [isApiFailed, setIsApiFailed] = useState(false);
	const [isApi, setIsApi] = useState(false);
	const [statusValue, setStatusValue] = React.useState();
	const [alertMessage, setAlertMessage] = React.useState("");
	const [alertDescription, setAlertDescription] = React.useState("");
	const [isAlertOpen, setIsAlertOpen] = React.useState(false);
	const [alertType, setAlertType] = React.useState("");
	const [selectedRadio, setSelectedRadio] = useState(TripTypeEnum.BUSINESS);
	const [tripSubType, setTripSubType] = useState("0");

	const handleClose = (value) => {
		setOpen(false);
		setTripSubType("0");
		props.dialogClose(false, value);
	};

	useEffect(() => {
		if (props.selectedTrip) {
			setSelectedRadio(props.selectedTrip.tripType);
			if (props.selectedTrip.tripSubType) {
				setTripSubType(props.selectedTrip.tripSubType);
			}
		}
	}, [props.selectedTrip]);

	const setSelectedTrip = () => {
		props.setSelectedTrip(null);
	}

	const setIsFreshCall = () => {
		props.setIsFreshCall(true);
	}

	const switchTripApply = async () => {
		handleClose(false);
		let param: any = {};
		param.userId = props.userId;
		if (props && props.selectedTrip && props.selectedTrip.tripType !== undefined && props.selectedTrip.tripType !== null) {
			param.tripId = props.selectedTrip.tripId;
			param.tripType = selectedRadio;
			if (selectedRadio === TripTypeEnum.NOT_DRIVING) {
				// param.reason = reason;
				param.tripSubType = +tripSubType;
			} else {
				param.tripSubType = 0;
			}
			setIsApi(true);
			const data = await switchTrip(param);
			setIsApi(false);
			// setTripSubType(t(`SELECT_A_REASON_*`));
			setStatusValue(data.status.code);
			if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201)) {
				setSelectedTrip();
				setIsFreshCall();
				setAlertMessage(data.status.message ? data.status.message : t("SUCCESS"));
				setAlertType("success");
				let description = "";
				if (props.selectedTrip.tripType === TripTypeEnum.BUSINESS && selectedRadio == TripTypeEnum.PERSONAL) {
					description = t("TRIP_SUCCESSFULLY_SWITCHED_FROM_BUSINESS_TO_PERSONAL");
				} else if (props.selectedTrip.tripType === TripTypeEnum.PERSONAL && selectedRadio == TripTypeEnum.BUSINESS) {
					description = t("TRIP_SUCCESSFULLY_SWITCHED_FROM_PERSONAL_TO_BUSINESS");
				} else if (props.selectedTrip.tripType === TripTypeEnum.BUSINESS && selectedRadio == TripTypeEnum.NOT_DRIVING) {
					description = t("TRIP_SUCCESSFULLY_SWITCHED_FROM_BUSINESS_TO_I_AM_NOT_DRIVING");
				} else if (props.selectedTrip.tripType === TripTypeEnum.PERSONAL && selectedRadio == TripTypeEnum.NOT_DRIVING) {
					description = t("TRIP_SUCCESSFULLY_SWITCHED_FROM_PERSONAL_TO_I_AM_NOT_DRIVING");
				}

				setAlertDescription(description);
				setIsAlertOpen(true);
			} else {
				setIsApiFailed(true);
				changeApiStatusCodeFunc(data.status);
			}
		}
	}

	const changeApiStatusCodeFunc = (status) => {
		if (status.code && status.code !== 0 && status.code !== 200 && status.code !== 201) {
			setStatusValue(status.code);
			setAlertMessage(status.message ? status.message : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`);
			setIsAlertOpen(true);
		}
	};

	useEffect(() => {
		setOpen(props.dialogOpen);
	}, [props.dialogOpen])

	function handleChange(e) {
		try {
			setSelectedRadio(e.target.value);
		} catch (error) {
			console.log(error);
		}
	}

	function handleChangeReason(e) {
		try {
			setTripSubType(e.target.value);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		if (props && props.selectedTrip && props.selectedTrip.tripType !== undefined && props.selectedTrip.tripType !== null) {
			setSelectedRadio(props.selectedTrip.tripType);
		}
	}, [props])


	return (
		<>
			<CustomDialog onClose={() => handleClose(false)} aria-labelledby="customized-dialog-title" open={open} className={classes.switchTripDialog} >
				<IconButton aria-label="close" className={classes.closeButton} onClick={() => handleClose(false)} >
					<CloseIcon />
				</IconButton>
				<DialogContent className={classes.dialogContentWrapper}>
					<Box>
						<Grid container>
							<Grid item xs={12}>
								<Typography className={classes.switchTripDialogContentTitle}>
									{t("SWITCH_TRIP")}
								</Typography>
								<Typography className={classes.switchTripDialogContentSubTitle}>
									{t("BY_DEFAULT_ITS_A_BUSINESS_TRIP")}
								</Typography>
							</Grid>
						</Grid>
					</Box>
					<div className={classes.switchTripCardContainer}>
						<Box className={classes.switchTripCard}>
							<Box>
								<Radio
									className={classes.switchTripRadio}
									checked={selectedRadio == TripTypeEnum.BUSINESS}
									onChange={handleChange}
									value={TripTypeEnum.BUSINESS}
									name="switchTripRadio"
									classes={{ root: classes.switchTripRadio, checked: classes.checked }}
								/>
							</Box>
							<Box>
								<Typography className={classes.switchTripRadioLabel}>
									{t(`BUSINESS`)}
								</Typography>
								<Typography className={classes.switchTripRadioDescription}>
									{t(`use this option if you are driving for business it will recalculate your score on every trip`)}
								</Typography>
							</Box>
						</Box>
						<Box className={classes.switchTripCard}>
							<Box>
								<Radio
									className={classes.switchTripRadio}
									checked={selectedRadio == TripTypeEnum.PERSONAL}
									onChange={handleChange}
									value={TripTypeEnum.PERSONAL}
									name="switchTripRadio"
									classes={{ root: classes.switchTripRadio, checked: classes.checked }}
								/>
							</Box>
							<Box>
								<Typography className={classes.switchTripRadioLabel}>
									{t(`PRIVATE`)}
								</Typography>
								<Typography className={classes.switchTripRadioDescription}>
									{t(`use this option if you are driving for personal use it will not impact your business trip scores`)}
								</Typography>
							</Box>
						</Box>
						<Box className={classes.switchTripCard}>
							<Box>
								<Radio
									className={classes.switchTripRadio}
									checked={selectedRadio == TripTypeEnum.NOT_DRIVING}
									onChange={handleChange}
									value={TripTypeEnum.NOT_DRIVING}
									name="switchTripRadio"
									classes={{ root: classes.switchTripRadio, checked: classes.checked }}
								/>
							</Box>
							<Box>
								<Typography className={classes.switchTripRadioLabel}>
									{t(`I_WAS_NOT_DRIVING`)}
								</Typography>
								<Typography className={classes.switchTripRadioDescription}>
									{t(`use this option if you are not driving on the selected trip`)}
								</Typography>
							</Box>
						</Box>
					</div>
					{selectedRadio == TripTypeEnum.NOT_DRIVING &&
						<FormControl>
							<Select
								variant='outlined'
								className={classes.selectReason}
								value={tripSubType}
								onChange={handleChangeReason}
							>
								<MenuItem value="0">
									{t("SELECT_A_REASON_*")}
								</MenuItem>
								<MenuItem value={TripSubTypeEnum.PASSENGER}>{t("PASSENGER")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.BICYCLE}>{t("BICYCLE")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.BOAT}>{t("BOAT")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.BUS}>{t("BUS")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.FOOT}>{t("FOOT")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.MOTORCYCLE}>{t("MOTORCYCLE")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.AIRPLANE}>{t("AIRPLANE")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.TRAIN}>{t("TRAIN")}</MenuItem>
								<MenuItem value={TripSubTypeEnum.OTHER}>{t("OTHER")}</MenuItem>
							</Select>
						</FormControl>}
				</DialogContent>
				<DialogActions className={classes.switchDialogActionWrapper}>
					{isApi ? (<CustomPaper elevation={0} square>
						<CustomCircularProgress
							className={classes.switchTripDialogLoader}
						/>
					</CustomPaper>) : (
						<>
							<CustomButton className={classes.switchDialogActionButton} autoFocus onClick={switchTripApply} variant="contained" color="primary" {...((selectedRadio === TripTypeEnum.NOT_DRIVING && (tripSubType === "0")) || (props && props.selectedTrip !== undefined && props.selectedTrip !== null && props.selectedTrip.tripType === selectedRadio && props.selectedTrip.tripSubType === tripSubType) ? { "disabled": true } : {})}>
								{t("APPLY")}
							</CustomButton>
						</>

					)}


				</DialogActions>
			</CustomDialog>
			<ErrorAlert
				code={statusValue}
				message={alertMessage}
				description={alertDescription}
				isOpen={isAlertOpen}
				alertType={alertType}
				isClose={(isClose) => setIsAlertOpen(!isClose)}
			/>
		</>
	);
}
